import React, { useRef, useState } from 'react';
import { observer } from 'mobx-react';
import cn from 'classnames';
import { ConnectionType, IChildConnectionDTO, IParentConnectionDTO } from '../../../../../../../api/connections.dao';
import IconCircleWithDotsSVG from '../../../../../../../images/svg/circle-with-dots';
import IconCheckedSVG from '../../../../../../../images/svg/icons8-checked';
import { ChildConnectionDetailsPopover } from '../../../../shared/child-connection-details-popover/child-connection-details-popover';
import { CONNECTION_DETAILS_POPOVER_TRACKING_EVENTS } from '../../../../../../../tracking-service/tracking-values';
import { ChildConnectionsViewModel } from '../../../_meeting-connections-form/child-connections/child-connections.viewmodel';

export type AttendeeUniqueConnectionIndicatorProps = {
    parentConnection: IParentConnectionDTO | undefined;
    childConnection: IChildConnectionDTO | undefined;
    handleTrackChildCopyBtn?: (event: CONNECTION_DETAILS_POPOVER_TRACKING_EVENTS, type: string) => void;
    withLeftMargin: boolean;
    childConnectionsVM: ChildConnectionsViewModel;
    propsCustomLeft?: number;
};

export const AttendeeUniqueConnectionIndicator: React.FC<AttendeeUniqueConnectionIndicatorProps> = observer((props): JSX.Element => {
    const {
        parentConnection,
        childConnection,
        withLeftMargin,
        handleTrackChildCopyBtn,
        childConnectionsVM,
        propsCustomLeft,
    } = props;
    const [isPopoverOpen, setIsPopoverOpen] = useState<boolean>(false);
    const listItemRef = useRef(null);

    const togglePopover = (): void => {
        setIsPopoverOpen(prevState => !prevState);
    };

    const handleOpenPopover = (): void => {
        if (childConnection) {
            togglePopover();
        }
    };

    return (
        <div
            className={cn('attendee-connection__unique-icon', {
                'attendee-connection__unique-icon--margin-left': withLeftMargin,
                'attendee-connection__unique-icon--checked': !!childConnection,
                'attendee-connection__unique-icon--active': isPopoverOpen,
            })}
            onClick={handleOpenPopover}
            ref={listItemRef}
        >
            { !!childConnection
                ? <div className={'attendee-connection__unique-icon--wrapper'}>
                    <span className={'attendee-connection__unique-icon--checked-icon'}>
                        <IconCheckedSVG />
                        {childConnection?.type === ConnectionType.PanelistLink && <span className='attendee-connection__unique-panelist-child'>P</span>}
                    </span>
                    <ChildConnectionDetailsPopover
                        childConnection={childConnection}
                        isPopoverOpen={isPopoverOpen}
                        setIsPopoverOpen={setIsPopoverOpen}
                        listItemRef={listItemRef}
                        handleTrackChildCopyBtn={handleTrackChildCopyBtn}
                        openChildConnectionModal={childConnectionsVM.openChildConnectionEditModal}
                        parentConnectionId={parentConnection.meetingConnectionId}
                        deleteChildConnection={childConnectionsVM.openDeleteChildConnectionConfirmation}
                        propsCustomLeft={propsCustomLeft}
                    />
                </div>
                : !!parentConnection
                    ? <div className={cn('attendee-connection__unique-icon--wrapper')}>
                        <IconCircleWithDotsSVG />
                    </div>
                    : null
            }
        </div>
    );
});
